module.exports = __webpack_public_path__ + "assets/retina_TMoveDetailed.9861edff872236fba84891d4ec06775e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_TMoveDetailed.png
// module id = 734
// module chunks = 0